import PropTypes from 'prop-types';
import { VesselType } from 'common/entities/vessels/VesselTypes';
import { RankType } from 'common/entities/crew/RankTypes';

export const AggregationTypeState = PropTypes.shape({
  name: PropTypes.string,
  label: PropTypes.string
});

export const MatrixRuleTypeState = PropTypes.shape({
  id: PropTypes.number.isRequired,
  label: PropTypes.string,
  name: PropTypes.string,
  sort_index: PropTypes.number,
  created_at: PropTypes.string,
  updated_at: PropTypes.string
});

export const RulesState = PropTypes.shape({
  id: PropTypes.string.isRequired,
  type_id: PropTypes.number,
  rank_id: PropTypes.number,
  second_rank_id: PropTypes.number,
  aggregation_type: AggregationTypeState,
  threshold: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  rank: RankType,
  type: MatrixRuleTypeState,
  second_rank: RankType
});

export const MatricesState = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  name: PropTypes.string,
  vessels: PropTypes.arrayOf(VesselType),
  remarks: PropTypes.string,
  rules: PropTypes.arrayOf(RulesState)
});

export const MatrixType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  is_satisfied: PropTypes.bool.isRequired
});
